<template>
	<div class="skfaceios_help">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">使用说明</h1>
		<h3 class="doc_main_h3">产品功能概述</h3>
		<p class="doc_main_p">在<a href="https://skfrm.cn/" class='abq'>FRM</a> API-v1版本基础上规范接口名、参数名，必要时修改相关接口逻辑。</p>
		<h3 class="doc_main_h3">产品使用场景</h3>
		<p class="doc_main_p">基于SKFaceSDK与FRM平台的人脸门禁、人员考勤及会员识别等场景下的多终端人脸识别管理。</p>
		<h3 class="doc_main_h3">典型用户分析</h3>
		<p class="doc_main_p">人脸门禁机厂商、服务机器人厂商、教培/连锁机构CRM与收银系统厂商、智慧社区/办公/会展方案商与服务商。</p>
		<h3 class="doc_main_h3">使用FRM API的流程</h3>
		<p class="doc_main_p">
			
			<img src="../../../static/images/objectRecognition/frm/2.png" class="unity_1_png">
		</p>
		<p class="doc_main_p">所有接口均使用POST方法调用</p>
		<!-- <h3 class="doc_main_h3">
			使用说明	
		</h3>
		<p class="doc_main_p">1.SKFaceSDK 文件夹下为 SDK，请将 SKFaceSDK 文件夹添加到工程。</p>
		<p class="doc_main_p">2.添加 Accelerate.framework。</p>
		<p class="doc_main_p">3.在使用 SDK 类的后缀名改为.mm，也可以单独封装一个.mm 类调用 SDK(推荐后者)。</p>
		<p class="doc_main_p">4.SKFaceDemo 为 Demo 工程源码，可作为集成 SDK 的参考。</p>
		<p class="doc_main_p">5.接口调用请参考说明文档“SKFace-iOS 接口说明.pdf 。</p> -->
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../components/documentTitleBar';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
		},
		data(){
			return{
				isPathData:['FRM API-v2','使用说明'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../less/index.less';
	.skfaceios_help{
	}

	a:hover{
		color:#00a0e9;
	}
	.unity_1_png{
		display: block;
		width: 600px;
		// margin:20px auto;
	}
	.abq{
		color:#00a0e9;
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/FRMuserHelp.vue